import { createContext } from "react";

const MarcasContext = createContext();

export default MarcasContext;
